(function () {
  'use strict';

  /* Scroller for the brands slider: mouse drag-to-scroll (the shared helper in
     eb-drag-scroll.js; touch uses native scrolling) and arrows that page one
     card at a time. CSS scroll-snap settles the row after release. `is-dragging`
     is added only once a real drag starts, so a plain click on a logo link still
     fires.

     Two arrow pairs can exist (beside the heading / on the card's edges); CSS
     shows one per breakpoint, so bind and update every one. The header pair
     lives outside this element, so arrows are looked up from the section root.
     Arrows stay put and go disabled at the ends; the nav hides when the row
     doesn't scroll. Mirrors eb-blog-posts.js. */
  class EbBrandsScroller extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-eb-br-track]');
      if (!this.track) return;
      var scope = this.closest('.eb-brands') || this;
      this.navs = Array.prototype.slice.call(scope.querySelectorAll('[data-eb-br-nav]'));
      this.prevBtns = Array.prototype.slice.call(scope.querySelectorAll('[data-eb-br-prev]'));
      this.nextBtns = Array.prototype.slice.call(scope.querySelectorAll('[data-eb-br-next]'));

      window.EbDragScroll.attach(this.track);
      this.initArrows();

      if (window.ResizeObserver) {
        var self = this;
        this.ro = new ResizeObserver(function () {
          self.updateArrows();
        });
        this.ro.observe(this.track);
      }
    }

    disconnectedCallback() {
      if (this.ro) {
        this.ro.disconnect();
        this.ro = null;
      }
    }

    /* One card + gap per click; falls back to most of the viewport width. */
    step() {
      var cell = this.track.firstElementChild;
      if (!cell) return this.track.clientWidth * 0.85;
      var gap = parseFloat(getComputedStyle(this.track).columnGap);
      if (isNaN(gap)) gap = 0;
      return cell.getBoundingClientRect().width + gap;
    }

    initArrows() {
      var self = this;
      if (!this.prevBtns.length && !this.nextBtns.length) return;

      var reduce =
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function page(dir) {
        self.track.scrollBy({
          left: dir * self.step(),
          behavior: reduce ? 'auto' : 'smooth'
        });
      }

      this.prevBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          page(-1);
        });
      });
      this.nextBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          page(1);
        });
      });

      this.updateArrows();
      this.track.addEventListener('scroll', function () {
        self.updateArrows();
      });
      window.addEventListener('resize', function () {
        self.updateArrows();
      });
    }

    updateArrows() {
      if (!this.prevBtns || (!this.prevBtns.length && !this.nextBtns.length)) return;
      var track = this.track;
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      var scrollable = maxScroll > 1;
      var atStart = track.scrollLeft <= 0;
      var atEnd = track.scrollLeft >= maxScroll;

      this.navs.forEach(function (nav) {
        nav.hidden = !scrollable;
      });
      this.prevBtns.forEach(function (btn) {
        btn.disabled = atStart;
      });
      this.nextBtns.forEach(function (btn) {
        btn.disabled = atEnd;
      });
    }
  }

  if (!customElements.get('eb-brands-scroller')) {
    customElements.define('eb-brands-scroller', EbBrandsScroller);
  }
})();
